import { axiosGet, axiosPost } from '../ServiceBase.js';


/**
 * @param {*} afiliado
 * @returns string
 */
export const generarTokenFarmacia = async (idAfiliado) => {
  const token = await axiosPost('/v1/preserfar/farmacia/tokens', {
    idAfiliado: idAfiliado,
  });
  return token;
};
